// extracted by mini-css-extract-plugin
export var box = "_2f-2";
export var checkboxControl = "_2f-0";
export var checkboxRow = "_2f-9";
export var checked = "_2f-3";
export var descriptionSpacer = "_2f-b";
export var disabled = "_2f-4";
export var icon = "_2f-7";
export var input = "_2f-1";
export var labelSpacer = "_2f-a";
export var medium = "_2f-6";
export var small = "_2f-5";
export var text = "_2f-8";